import React, { useState, useEffect } from "react";

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Sample slides data - replace with your actual images and content
  const slides = [
    {
      id: 1,
      image: "../images/slide-image-1.jpg",
      title: "Welcome to Newsmedia Association of India",
      subtitle: "Empowering Media Professionals Across India",
      description:
        "Join the largest network of media professionals and journalists in India",
      ctaText: "Join Now",
      ctaLink: "/apply",
    },
    {
      id: 2,
      image: "../images/slide-image-2.jpg",
      title: "Advocating for Media Freedom",
      subtitle: "Protecting Press Rights and Journalism Ethics",
      description:
        "We stand for independent journalism and media rights in India",
      ctaText: "Learn More",
      ctaLink: "/about",
    },
    {
      id: 3,
      image: "../images/slide-image-3.jpg",
      title: "Latest Media Updates",
      subtitle: "Stay Informed with NAI News",
      description:
        "Get the latest updates from the media industry and our association",
      ctaText: "Read News",
      ctaLink: "/nai-news",
    },
    {
      id: 4,
      image: "../images/slide-image-4.jpg",
      title: "Welcome to Newsmedia Association of India",
      subtitle: "Empowering Media Professionals Across India",
      description:
        "Join the largest network of media professionals and journalists in India",
      ctaText: "Join Now",
      ctaLink: "/apply",
    },
    {
      id: 5,
      image: "../images/slide-image-5.jpg",
      title: "Advocating for Media Freedom",
      subtitle: "Protecting Press Rights and Journalism Ethics",
      description:
        "We stand for independent journalism and media rights in India",
      ctaText: "Learn More",
      ctaLink: "/about",
    },
    {
      id: 6,
      image: "../images/slide-image-6.jpg",
      title: "Latest Media Updates",
      subtitle: "Stay Informed with NAI News",
      description:
        "Get the latest updates from the media industry and our association",
      ctaText: "Read News",
      ctaLink: "/nai-news",
    },
    {
      id: 7,
      image: "../images/slide-image-7.jpg",
      title: "Welcome to Newsmedia Association of India",
      subtitle: "Empowering Media Professionals Across India",
      description:
        "Join the largest network of media professionals and journalists in India",
      ctaText: "Join Now",
      ctaLink: "/apply",
    },
    {
      id: 8,
      image: "../images/slide-image-8.jpg",
      title: "Advocating for Media Freedom",
      subtitle: "Protecting Press Rights and Journalism Ethics",
      description:
        "We stand for independent journalism and media rights in India",
      ctaText: "Learn More",
      ctaLink: "/about",
    },
    {
      id: 9,
      image: "../images/slide-image-9.jpg",
      title: "Latest Media Updates",
      subtitle: "Stay Informed with NAI News",
      description:
        "Get the latest updates from the media industry and our association",
      ctaText: "Read News",
      ctaLink: "/nai-news",
    },
    {
      id: 10,
      image: "../images/slide-image-10.jpg",
      title: "Welcome to Newsmedia Association of India",
      subtitle: "Empowering Media Professionals Across India",
      description:
        "Join the largest network of media professionals and journalists in India",
      ctaText: "Join Now",
      ctaLink: "/apply",
    },
    {
      id: 11,
      image: "../images/slide-image-11.jpg",
      title: "Advocating for Media Freedom",
      subtitle: "Protecting Press Rights and Journalism Ethics",
      description:
        "We stand for independent journalism and media rights in India",
      ctaText: "Learn More",
      ctaLink: "/about",
    },
    {
      id: 12,
      image: "../images/pcr-slide.jpg",
      title: "Latest Media Updates",
      subtitle: "Stay Informed with NAI News",
      description:
        "Get the latest updates from the media industry and our association",
      ctaText: "Read News",
      ctaLink: "/nai-news",
    },
  ];

  // Auto slide transition
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  // Manual slide navigation
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative w-full aspect-[1024/430] max-h-[80vh] overflow-hidden bg-white">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === currentSlide ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`Slide ${slide.id}`}
            className="w-full h-full object-contain"
          />
        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 z-20 bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full transition-all duration-300"
        aria-label="Previous slide"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-20 bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full transition-all duration-300"
        aria-label="Next slide"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide
                ? "bg-white scale-125"
                : "bg-white bg-opacity-50 hover:bg-opacity-75"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Progress Bar */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-white bg-opacity-30 z-20">
        <div
          className="h-full bg-white transition-all duration-5000 ease-linear"
          style={{
            width: `${((currentSlide + 1) / slides.length) * 100}%`,
            transition: "width 5s linear",
          }}
        />
      </div>
    </div>
  );
};

export default Hero;
